import React from 'react';
import CyberAssociationJunior2024  from 'views/CyberAssociationJunior2024';
const ClassAssembly11CPage = () => {
    return <CyberAssociationJunior2024 />;
  };
  
  export default ClassAssembly11CPage;

  